// Marketplace Search Language & Loading V1, task 1 — pure decision logic for
// whether ColdStartBanner should render, extracted out of the component so
// it can be unit-tested without a DOM (this repo's test suite runs vitest in
// a node environment; no jsdom/testing-library is installed).
//
// The rule: the full-screen Rhea loading overlay and this banner must never
// both be visible at once. The overlay always wins — this banner is only
// eligible to show when the overlay is not on screen.
export function shouldShowColdStartBanner(
  bannerRequested: boolean,
  isOverlayVisible: boolean,
): boolean {
  return bannerRequested && !isOverlayVisible;
}
